module.exports = __webpack_public_path__ + "static/media/robotics-icon.402c27e3.png";